<template>
    <div>
        <el-row class="bottom20">
            <el-table :data="kpiPageInfo.tableData" :row-class-name="tableRowClassName"  style="width: 100%">
                <el-table-column label="工单编号">

                    <template slot="header" slot-scope="scope">
                        工单编号<br>
                        <el-input size="mini" v-model="searchParams.kpino"
                                  class="width70"></el-input>
                    </template>

                    <template slot-scope="scope">
                        <el-button @click="queryKpiDetail(scope.row)" type="text" size="mini">
                            {{scope.row.kpino}}
                        </el-button>
                    </template>

                </el-table-column>
                <el-table-column prop="deptid" :formatter="formatDept" label="数据中心">
                    <template slot="header" slot-scope="scope">
                        数据中心<br>
                        <dept-select size="mini" ref="deptSelect" allowAll="true" multiple=true v-model="searchParams.depts">
                        </dept-select>
                    </template>
                </el-table-column>
                <el-table-column prop="kpidate" :formatter="formatKpiDate" label="考评月份">
                    <template slot="header" slot-scope="scope">
                        考评月份<br>
                        <br><br>
                    </template>
                </el-table-column>
                <el-table-column prop="status" label="状态">
                    <template slot="header" slot-scope="scope">
                        状态<br/>
                        <dictionary-select v-model="searchParams.status" :factory-name="'domain'" :params="'KPISTATUS'" filterable clearable size="mini"></dictionary-select>
                    </template>
                    <template slot-scope="scope">
                        <dictionary-text :factory-name="'domain'" :params="'KPISTATUS'" :value="scope.row.status"></dictionary-text>
                    </template>
                </el-table-column>
            </el-table>
        </el-row>
        <el-row type="flex" class="row-bg" justify="end">
            <el-pagination align="right" @size-change="handleSizeChange"
                           @current-change="handleCurrentChange"
                           :current-page="currentPage"
                           :page-sizes="pageSizes" :page-size="pageSize"
                           layout="total, sizes, prev, pager, next, jumper"
                           :total="kpiPageInfo.total">
            </el-pagination>
        </el-row>
    </div>
</template>

<script type="text/javascript">

import DeptSelect from '@/components/dept'
import DomainSelect from '@/components/domainaln'
import DictionarySelect from '@/components/common/DictionarySelect'
import DictionaryText from '@/components/common/DictionaryText'

import {debounce} from '../../util'
import {createNamespacedHelpers} from "vuex";
import AthubCloudApi from "../../api/athubCloud";

const kpiNSHelper = createNamespacedHelpers( "kpi" );

    export default {

        name: "KpiTable",

        components: {
            DomainSelect,
            DeptSelect,
            DictionarySelect,
            DictionaryText,
        },

        props: {
            searchParams: {},
        },

        data() {
            return {

                //表格翻页查询条件
                currentPage: 1,
                pageSize: 10,
                pageSizes: [10, 25, 50, 100],
                visited: [],

            }
        },

        methods: {

            ...kpiNSHelper.mapActions(['getKpiPageInfo']),
            ...kpiNSHelper.mapMutations(['setKpiInfo']),

            async queryTable() {
                let pageParams = {
                    'currentPage': this.currentPage,
                    'pageSize': this.pageSize,
                }

                if (this.searchParams.depts == null || this.searchParams.depts.length == 0) {
                    let deptInfo = await AthubCloudApi.fetchDeptListByAuthSites();
                    pageParams.depts = deptInfo.map(e => e.id);
                }

                let params = {...this.searchParams, ...pageParams};
                await this.getKpiPageInfo(params);
            },

            handleSizeChange(val) {
                this.pageSize = val;
            },
            handleCurrentChange(val) {
                this.currentPage = val;
            },

            tableRowClassName({row, rowIndex}) {
                let rowClassName = '';
                if (this.visited.indexOf(row.id) != -1) {
                    rowClassName += ' visited';
                }
                return rowClassName;
            },

            formatDept(row, column) {
                let deptDesc = '';
                this.$refs.deptSelect.deptList.forEach(e => {
                    if (row[column.property] == e.id) {
                        deptDesc = e.name;
                    }
                });
                return deptDesc;
            },

            formatKpiDate(row, column){
                return new Date(row[column.property]).Format('yyyy-MM');
            },

            queryKpiDetail(row) {
                if (this.visited.indexOf(row.id) == -1) {
                    this.visited.push(row.id);
                }
                this.$emit('showDetailTab');
                this.setKpiInfo(row);
            },

        },

        mounted() {
            this.queryTable();
        },

        computed: {
            ...kpiNSHelper.mapGetters(['kpiPageInfo']),
        },

        watch: {

            pageSize: {
                handler() {
                    this.queryTable();
                },
            },

            currentPage: {
                handler() {
                    this.queryTable();
                },
            },

            searchParams: {
                deep: true,
                handler: debounce(function (newVal, oldVal) {
                    this.kpiPageInfo.total = 0;
                    this.kpiPageInfo.tableData = [];
                    this.currentPage = 1;
                    this.queryTable();
                }, 500)
            },

        },


    }
</script>
<style>

</style>